function Terms() {
  const updated = "These terms were last reviewed in " + new Date().getFullYear() + ".";
  return (
    <main className="ix-page">
      <header className="ix-hero">
        <div className="ix-shell">
          <span className="ix-eyebrow is-gray">Legal</span>
          <h1>Terms of Service</h1>
        </div>
      </header>

      <section className="ix-section">
        <div className="ix-shell ix-prose">
          <p>
            These terms govern your use of the Intellusion website and the information
            on it. By using this site, you agree to them. {updated}
          </p>

          <h2>Use of the site</h2>
          <p>
            You may use this site to learn about our products, contact us, and apply for
            roles. Do not use it to break the law, infringe others&rsquo; rights, or
            disrupt the service.
          </p>

          <h2>Products</h2>
          <p>
            Individual products such as StockLens have their own terms that apply when
            you use them. Where a product links out from this site, that product&rsquo;s
            terms govern your use of it.
          </p>

          <h2>Intellectual property</h2>
          <p>
            The content, branding, and design on this site belong to Intellusion or its
            licensors. Open-source projects we publish are governed by their own
            licenses.
          </p>

          <h2>No warranty</h2>
          <p>
            The information on this site is provided as is, without warranties of any
            kind. We work to keep it accurate but do not guarantee it is complete or
            error free.
          </p>

          <h2>Limitation of liability</h2>
          <p>
            To the extent permitted by law, Intellusion is not liable for indirect or
            consequential losses arising from your use of this site.
          </p>

          <h2>Changes</h2>
          <p>
            We may update these terms as our products and business change. Continued use
            of the site means you accept the current version.
          </p>

          <h2>Contact</h2>
          <p>
            Questions about these terms? Email us at{" "}
            <a href="mailto:osama@intellusionai.com">osama@intellusionai.com</a>.
          </p>
        </div>
      </section>
    </main>
  );
}

export default Terms;
